import React, { Component } from 'react';
import {Button, Checkbox} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.config) {
            const { config } = this.props;

            this.state = {
                affid: config.affid,
                name: config.name,
                zone: config.zone,
                creative: config.creative,
                auth: config.auth,
                factor: config.factor,
                weekendFactor: config.weekendFactor,
                mgidStyle: config.mgidStyle,
                paused: config.paused,
                roi: config.roi,
                type: config.type,
                monetization: config.monetization,
                partnerId: config.partnerId ? config.partnerId.toString() : null,
                update: true
            };
        }
        else {
            this.state = {
                affid: '',
                name: '',
                zone: '',
                creative: '',
                auth: '',
                factor: '',
                weekendFactor: null,
                mgidStyle: 0,
                roi: '',
                partnerId: '',
                type: '',
                monetization: '',
                paused: 0
            };
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    handleCheckboxChange(event) {
        const { name, checked } = event.target;

        this.setState({ [name]: checked ? 1 : 0 });
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="affid"
                        label="Affid:"
                        onChange={this.handleFieldChange}
                        value={this.state.affid}
                        type={'number'}
                        step={'1'}
                        min={'600000'}
                        required
                    />
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <SelectWrap
                        value={this.state.zone}
                        name="zone"
                        label="Zone:"
                        values={[ 'EU', 'US' ]}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        value={this.state.creative}
                        name="creative"
                        label="Creative:"
                        values={[ 'MS', 'SOFT', 'ADULT', 'IPP', 'IPP_MS', 'BIDDER' ]}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        value={this.state.type}
                        name="type"
                        label="Type:"
                        values={[ 'new', 'old' ]}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        value={this.state.monetization}
                        name="monetization"
                        label="Monetization:"
                        values={[ 'all', 'valid' ]}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        value={this.state.partnerId}
                        name="partnerId"
                        label="Partner:"
                        values={this.props.partners}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <FieldGroup
                        name="auth"
                        label="Auth:"
                        onChange={this.handleFieldChange}
                        value={this.state.auth}
                        required
                    />
                    <FieldGroup
                        name="factor"
                        label="Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.factor}
                        type={'number'}
                        step={'0.01'}
                        max={'10'}
                        required
                    />
                    <FieldGroup
                        name="weekendFactor"
                        label="Weekend Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.weekendFactor}
                        type={'number'}
                        step={'0.01'}
                        max={'10'}
                    />
                    <FieldGroup
                        name="roi"
                        label="ROI:"
                        onChange={this.handleFieldChange}
                        value={this.state.roi}
                        type={'number'}
                        step={'0.01'}
                        max={'10'}
                    />
                    <Checkbox onChange={this.handleCheckboxChange} name="mgidStyle" checked={this.state.mgidStyle}>
                        Mgid Style
                    </Checkbox>
                    <Checkbox onChange={this.handleCheckboxChange} name="paused" checked={this.state.paused}>
                        Paused
                    </Checkbox>

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/PushapiConfig/components/Form/index.js